<template lang="pug">
    .table_row 
      .table_small(:class="[textAlign1, fontWeight1]") {{cols.title}}
      .table_small(:class="[textAlign2, fontWeight2]") {{cols.sub_title}}
      .table_small(:class="[textAlign3, fontWeight3]") {{cols.text}}
</template>

<script>
import { get } from '@/helpers';

export default {
    name: 'Row',
    mounted() {
        if (this.id) {
            const state = this.getCollapseState();
            if (state) {
                this.isCollapsed = state[this.id];
            }
        }
    },
    data() {
        return {
            //delay: 150,
        };
    },
    props: {
        cols: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        odd() {
            return this.index % 2 == 0;
        },

        settings() {
            return get(this.cols, 'settings', []);
        },

        textAlign1() {
            let textAlign = 'text-left';
            if (this.settings && this.settings.length) {
                const setting = this.settings.find(setting => setting.key === 'textAlign-1');
                if (setting && setting.value) textAlign = setting.value;
            }
            return textAlign;
        },
        fontWeight1() {
            let fontWeight = 'font-normal';
            if (this.settings && this.settings.length) {
                const setting = this.settings.find(setting => setting.key === 'fontWeight-1');
                if (setting && setting.value) fontWeight = setting.value;
            }
            return fontWeight;
        },

        textAlign2() {
            let textAlign = 'text-left';
            if (this.settings && this.settings.length) {
                const setting = this.settings.find(setting => setting.key === 'textAlign-2');
                if (setting && setting.value) textAlign = setting.value;
            }
            return textAlign;
        },
        fontWeight2() {
            let fontWeight = 'font-normal';
            if (this.settings && this.settings.length) {
                const setting = this.settings.find(setting => setting.key === 'fontWeight-2');
                if (setting && setting.value) fontWeight = setting.value;
            }
            return fontWeight;
        },

        textAlign3() {
            let textAlign = 'text-left';
            if (this.settings && this.settings.length) {
                const setting = this.settings.find(setting => setting.key === 'textAlign-3');
                if (setting && setting.value) textAlign = setting.value;
            }
            return textAlign;
        },
        fontWeight3() {
            let fontWeight = 'font-normal';
            if (this.settings && this.settings.length) {
                const setting = this.settings.find(setting => setting.key === 'fontWeight-3');
                if (setting && setting.value) fontWeight = setting.value;
            }
            return fontWeight;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.table_row
  @apply table-row

  &:first-child
    .table_small
      @apply border-t

  .table_small
    @apply table-cell border-b border-r
    padding: 6px 10px
    &:first-child
      @apply border-l
</style>
